import React from "react";
import { MDBDataTableV5 } from "mdbreact";
export default function Basic(props) {
    const getCurrencySymbol = (currencyName) => {
        const currencySymbols = {
            'USD': '$',
            'EUR': '€',
            'GBP': '£',
            'JPY': '¥',
            'CAD': 'C$',
            'AUD': 'A$',
            'CHF': 'CHF',
            'CNY': '¥',
            'INR': '₹',
            'MXN': 'MX$',
            'BRL': 'R$',
            'ZAR': 'R',
            'KRW': '₩',
            'RUB': '₽',
            'SGD': 'S$',
            'NZD': 'NZ$',
            'HKD': 'HK$',
            'NOK': 'kr',
            'SEK': 'kr',
            'DKK': 'kr',
            'PLN': 'zł',
            'THB': '฿',
            'IDR': 'Rp',
            'MYR': 'RM',
            'PHP': '₱',
            'CZK': 'Kč',
            'ILS': '₪',
            'AED': 'د.إ',
            'SAR': 'ر.س',
        };
        return currencySymbols[currencyName] || currencyName || '$';
    };
    let userAttributes;
    let i = 0;
    let datatable;
    [datatable] = React.useState("");

    const getBillingCyclePrice = (plan) => {
        // Try the provided currencyName key first
        if (props.currencyName) {
            const val = plan["BillingCyclePrice." + props.currencyName];
            if (val !== undefined && val !== null) {
                return getCurrencySymbol(props.currencyName) + (val / 100).toFixed(2);
            }
        }
        // Fall back to scanning for any BillingCyclePrice.* key
        const priceKey = Object.keys(plan).find((k) => k.startsWith("BillingCyclePrice."));
        if (priceKey) {
            const currency = priceKey.split(".")[1];
            const val = plan[priceKey];
            if (val !== undefined && val !== null) {
                return getCurrencySymbol(currency) + (val / 100).toFixed(2);
            }
        }
        return "N/A";
    };
    if (props.servicePlans !== undefined) {
        userAttributes = [];
        for (const key of Object.keys(props.servicePlans)) {
            userAttributes.push({
                servicePlanName: props.servicePlans[key]["ServicePlanName"],
                servicePlanDescription:
                    props.servicePlans[key]["ServicePlanDescription"],
                downloadkbps: props.servicePlans[key]["DownloadKbps"],
                uploadkbps: props.servicePlans[key]["UploadKbps"],
                concurrentdevices: props.servicePlans[key]["ConcurrentDevices"],
                billingCycleHours: props.servicePlans[key]["BillingCycleHours"],
                billingCyclePrice: getBillingCyclePrice(props.servicePlans[key]),
                trialCycles: props.servicePlans[key]["TrialCycles"],
                action: (
                    <>
                    {props.servicePlans[key]["GloballyAvailablePlan"] ? 
                    "":
                        <div className="renewConfirmButton1">
                            <a
                                href="#link"
                                onClick={() => props.disablePlanConfirm(key)}
                                className="expirationAction"
                                disabled={props.servicePlans[key]["GloballyAvailablePlan"]}
                            >
                                Disable
                            </a>
                        </div>
                    }
                    </>
                ),
            });
            i = i + 1;
        }
    }
    datatable = {
        columns: [
            {
                label: "Name",
                field: "servicePlanName",
            },
            {
                label: "Description",
                field: "servicePlanDescription",
            },
            {
                label: "Download(kbps)",
                field: "downloadkbps",
            },
            {
                label: "Upload(kbps)",
                field: "uploadkbps",
            },
            {
                label: "Concurrent Devices",
                field: "concurrentdevices",
            },
            {
                label: "Billing Cycle Hours",
                field: "billingCycleHours",
            },
            {
                label: "Billing Cycle Price",
                field: "billingCyclePrice",
            },
            {
                label: "Trial Cycles",
                field: "trialCycles",
            },
            {
                label:
                    sessionStorage.getItem("customerSupport") > 0
                        ? ""
                        : "Action",
                field:
                    sessionStorage.getItem("customerSupport") > 0
                        ? ""
                        : "action",
            },
        ],
        rows: userAttributes,
    };
    return (
        <MDBDataTableV5
            sortable={true}
            responsive
            hover
            data={datatable}
            searchTop={true}
            searchBottom={false}
            searchLabel="Filter"
            paging={false}
            className="servicePlans"
            info={false}
            noRecordsFoundLabel="No Service Plans Found"
            sortRows={["activated"]}
        />
    );
}
